<app-service-code *ngFor="let code of group.codes" [code]="code" [mode]="'add'" (action)="codeAction($event)"></app-service-code>